export interface IServerSideExperimentBucketManager {
  setServerSideExperimentBucketMap: (bucketMap: Record<string, string>) => void
  getServerSideExperimentBucketMap: () => Record<string, string>
  getExperimentBucket: (experimentName: string) => string | undefined
  hasExperiment: (experimentName: string) => boolean
  getAllExperimentNames: () => string[]
  getBucketEntries: () => { experimentName: string; bucketName: string }[]
}

class ServerSideExperimentBucketManager implements IServerSideExperimentBucketManager {
  private serverSideExperimentBucketMap: Record<string, string> = {}

  setServerSideExperimentBucketMap = (bucketMap: Record<string, string>) => {
    this.serverSideExperimentBucketMap = { ...bucketMap }
  }

  getServerSideExperimentBucketMap = (): Record<string, string> => {
    return { ...this.serverSideExperimentBucketMap }
  }

  getExperimentBucket = (experimentName: string): string | undefined => {
    return this.serverSideExperimentBucketMap[experimentName]
  }

  hasExperiment = (experimentName: string): boolean => {
    return experimentName in this.serverSideExperimentBucketMap
  }

  getAllExperimentNames = (): string[] => {
    return Object.keys(this.serverSideExperimentBucketMap)
  }

  getBucketEntries = (): { experimentName: string; bucketName: string }[] => {
    return Object.entries(this.serverSideExperimentBucketMap).map(([experimentName, bucketName]) => ({
      experimentName,
      bucketName,
    }))
  }
}

const serverSideExperimentBucketManager = new ServerSideExperimentBucketManager()

if (typeof window !== 'undefined') {
  window.serverSideExperimentBucketManager = serverSideExperimentBucketManager
}

export default serverSideExperimentBucketManager
